import 'reflect-metadata';
import {
  Expose,
  plainToInstance,
  instanceToPlain,
  Type,
} from 'class-transformer';

export class HomeRank {
  criteria: string[];

  @Expose({ name: 'current_rank' })
  currentRank?: number;

  @Expose({ name: 'rank_achievements' })
  @Type(() => HomeAchievedRank)
  achievedRanks: HomeAchievedRank[];

  @Expose({ name: 'higher_ranks' })
  @Type(() => HomeNextRank)
  higherRanks: HomeNextRank[];

  @Expose({ name: 'criteria_achieved' })
  @Type(() => RankCriteriaAchieved)
  criteriaAchieved: RankCriteriaAchieved;

  @Expose({ name: 'downline_rank_name' })
  downlineRankName?: string;

  constructor(
    criteria: string[],
    currentRank: number | undefined,
    achievedRanks: HomeAchievedRank[],
    higherRanks: HomeNextRank[],
    criteriaAchieved: RankCriteriaAchieved,
    downlineRankName?: string
  ) {
    this.criteria = criteria;
    this.currentRank = currentRank;
    this.achievedRanks = achievedRanks;
    this.higherRanks = higherRanks;
    this.criteriaAchieved = criteriaAchieved;
    this.downlineRankName = downlineRankName;
  }

  static fromJson(json: Record<string, any>): HomeRank {
    return plainToInstance(HomeRank, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}

export class HomeAchievedRank {
  id: number;

  name: string;

  bonus: string;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  dateCreated: Date;

  @Expose({ name: 'referral_count' })
  referralCount?: number;

  pv?: string;

  tv?: string;

  constructor(
    id: number,
    name: string,
    bonus: string,
    dateCreated: Date,
    referralCount: number | undefined,
    pv: string | undefined,
    tv: string | undefined
  ) {
    this.id = id;
    this.name = name;
    this.bonus = bonus;
    this.dateCreated = dateCreated;
    this.referralCount = referralCount;
    this.pv = pv;
    this.tv = tv;
  }

  static fromJson(json: Record<string, any>): HomeAchievedRank {
    return plainToInstance(HomeAchievedRank, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}

export class HomeNextRank {
  id: number;

  name: string;

  bonus: string;

  @Expose({ name: 'referral_count' })
  referralCount: number;

  @Expose({ name: 'downline_count' })
  downlineCount: number;

  @Expose({ name: 'min_legs_with_rank' })
  minLegsWithRank: number;

  sales: string;

  constructor(
    id: number,
    name: string,
    bonus: string,
    referralCount: number,
    downlineCount: number,
    sales: string,
    minLegsWithRank: number
  ) {
    this.id = id;
    this.name = name;
    this.bonus = bonus;
    this.referralCount = referralCount;
    this.downlineCount = downlineCount;
    this.sales = sales;
    this.minLegsWithRank = minLegsWithRank;
  }

  static fromJson(json: Record<string, any>): HomeNextRank {
    return plainToInstance(HomeNextRank, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}

export class RankCriteriaAchieved {
  @Expose({ name: 'referral_count' })
  referralCount?: number;

  @Expose({ name: 'downline_count' })
  downlineCount?: number;

  @Expose({ name: 'min_legs_with_rank' })
  minLegsWithRank?: number;

  sales?: string;

  constructor(
    referralCount: number | undefined,
    downlineCount: number | undefined,
    sales: string | undefined,
    minLegsWithRank: number | undefined
  ) {
    this.referralCount = referralCount;
    this.downlineCount = downlineCount;
    this.sales = sales;
    this.minLegsWithRank = minLegsWithRank;
  }

  static fromJson(json: Record<string, any>): RankCriteriaAchieved {
    return plainToInstance(RankCriteriaAchieved, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
